import { useCallback, useEffect, useRef } from 'react';

import type { SycurioEventType } from '../../../services/commonCheckout/commonSycurioTelephonicEntryService';
import commonSycurioTelephonicEntryService from '../../../services/commonCheckout/commonSycurioTelephonicEntryService';

type CleanupRefType = {
  shouldCallDoneOrDeleteService: boolean;
  eventType: SycurioEventType;
};

export default function useTelephonicEntryCleanup({
  checkoutSessionId,
}: {
  checkoutSessionId: string;
}) {
  const cleanupDetails = useRef<CleanupRefType>({
    shouldCallDoneOrDeleteService: false,
    eventType: 'onDelete',
  });

  const triggerDoneOrDeleteService = useCallback(
    (cleanup: CleanupRefType) => {
      cleanupDetails.current = cleanup;
    },
    [],
  );

  useEffect(() => {
    return () => {
      const { shouldCallDoneOrDeleteService, eventType } =
        cleanupDetails.current;
      if (shouldCallDoneOrDeleteService) {
        commonSycurioTelephonicEntryService({
          eventType,
          checkoutSessionId,
          method: 'DELETE',
        }).catch(() => ({}));
      }
    };
  }, [checkoutSessionId]);
  return {
    triggerDoneOrDeleteService,
  };
}
